import { getConfigWithMetadata, hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { deleteSearchAlert as generatedDeleteSearchAlert } from '@generated/search-bff/controllers/search-alert/search-alert';

/**
 * Delete a search alert using the `/api/v4/searchalert/alert/{searchAlertId}` endpoint.
 * Requires a valid JWT token in the `apiConfig`.
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/deleteSearchAlert Search API Documentation}
 */
export async function deleteSearchAlert(searchAlertId: string, apiConfig: ApiConfig): Promise<ApiResult<void>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'deleteSearchAlert');

    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
      );
    }

    await generatedDeleteSearchAlert(searchAlertId, _apiConfig);
    return { status: 'success', data: undefined };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
